<template>
  <div>
    <div v-for="item in folderMarkerList" :key="'folderMarker'+item.labelName">
      <folder-marker :folderMarkerSize="folderMarkerSize" :folderMarkerInfo="item" @clickFolderMarker="clickFolderMarker"></folder-marker>
    </div>
  </div>
</template>

<script>
import FolderMarker from "@/views/globe/globe_marker/FolderMarker";
export default {
  name: "FolderMarkerEntry",
  props:['folderMarkerList','folderMarkerSize'],
  components: {FolderMarker},
  methods:{
    clickFolderMarker(markerInfo){
      this.$emit("clickFolderMarker",markerInfo)
    }
  }
}
</script>

<style scoped>

</style>